import React, { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { API, useAuth } from "../context/AuthContext";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const hasProcessed = useRef(false);
    const { refresh } = useAuth();

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || window.location.hash;
        const params = new URLSearchParams(hash.replace(/^#/, ""));
        const session_id = params.get("session_id");

        if (!session_id) {
            navigate("/login", { replace: true });
            return;
        }

        (async () => {
            try {
                await axios.post(
                    `${API}/auth/google/session`,
                    { session_id },
                    { withCredentials: true }
                );
                await refresh();
                // Clear the hash and go to dashboard
                window.history.replaceState(null, "", window.location.pathname);
                navigate("/dashboard", { replace: true });
            } catch (err) {
                console.error("Auth callback failed", err);
                navigate("/login", { replace: true });
            }
        })();
    }, [location, navigate, refresh]);

    return (
        <div className="min-h-screen flex items-center justify-center">
            <p className="text-muted font-serif text-xl">Aligning the stars...</p>
        </div>
    );
}
